import Dict from '@/utils/dict-utils'

// 项目登记状态
export const registerStatusDict = new Dict({
  EDITING: {
    label: '编辑中',
    value: 1,
    type: 'primary',
    permission: ['edit', 'del']
  },
  PUBLISHED: {
    label: '已发布',
    value: 3,
    type: 'warning',
    permission: ['void', 'detail']
  },
  RELATED: {
    label: '已关联',
    value: 4,
    type: 'success',
    permission: ['detail']
  },
  ABOLISHED: {
    label: '已作废',
    value: 5,
    type: 'danger',
    permission: ['cancelVoid', 'detail']
  }
})

// 投资类型
export const registerInvestTypeDict = new Dict({
  OWN: { label: '自主投资', value: 1 },
  CONSTRUCTION: { label: '施工承揽', value: 2 },
  ENTRUST: { label: '代建项目', value: 3 }
})

// 是否集中采购
export const registerIsFocusPurchaseDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 2 }
})

// 是否为登记项目类型
export const isRegisterTypeDict = new Dict({
  YES: { label: '是', value: 1 },
  NO: { label: '否', value: 0 }
})
